<template>
    <v-form ref="UsernameRecoveryOptions" v-model="valid" lazy-validation>
        <div class="username-recovery__reset-title" v-if="!codeSent">
            {{loginConstants.WHERE_TO_SEND_USERNAME_RESET_CODE}}
        </div> 
        <v-layout row mb-4 v-if="!codeSent">

            <v-flex xs2>
                 <v-icon>email</v-icon>
            </v-flex>

            <v-flex xs10>
                   <v-checkbox
                        :v-if="userRecoveryOptions.email"
                        color="primary"
                        data-qe-id="username-recovery_email_checkbox"
                        :value="userRecoveryOptions.email"
                        :label="userRecoveryOptions.email"
                        v-model="email.primaryEmailCheckbox"
                   ></v-checkbox>
                    <v-checkbox
                        :v-if="userRecoveryOptions.secondaryEmail"
                        color="primary"
                        data-qe-id="username-recovery_secondary-email_checkbox"
                        :value="userRecoveryOptions.secondaryEmail"
                        :label="userRecoveryOptions.secondaryEmail"
                        v-model="email.secondaryEmailCheckbox"
                    ></v-checkbox>
            </v-flex>
        </v-layout>
        <v-flex v-if="codeSent && !isSubmitting">
            <div class="username-recovery__success">
                <div class="username-recovery__success-message">{{loginConstants.USERNAME_EMAIL_SUCCESS_1}}
                <span class="username-recovery__success-email">{{selectedRecoveryDetails}}</span>
                </div>
                <v-btn
                    id="resend_recovery_btn"
                    data-qe-id="resend_recovery_btn"
                    @click="submit"
                    :disabled="isSubmitting"
                    color="ypo_blue" class="mb-3"
                    flat
            >
                <v-icon color="ypo_blue_secondary" left>replay</v-icon>
                {{loginConstants.RESEND_EMAIL}}
            </v-btn>
            </div>
        </v-flex>
        <login-error></login-error>
        <v-card-actions>
            <v-layout row wrap>
                <v-btn
                        :flat="!codeSent"
                        large
                        id="return_to_home_btn"
                        data-qe-id="return_to_home_btn"
                        block
                        :class="codeSent ? 'white--text' : 'ypo_blue--text'"
                        :color="codeSent ? 'ypo_blue' : ''"
                        @click="returnToLogin()"
                >
                    {{!codeSent ? loginConstants.CANCEL : loginConstants.RETURN_TO_LOGIN}}
                </v-btn>
                <v-btn  v-if="!codeSent"
                        id="submit_username_recovery_btn"
                        data-qe-id="submit_username_recovery_btn"
                        color="ypo_blue"
                        class="white--text"
                        @click="submit"
                        :disabled="isSubmitting || checkEmptyObject || !valid"
                        large
                        block
                >
                    {{loginConstants.SUBMIT}}
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-form>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import { storeAction } from '../../../store/storeActions.constant';
    import { storeGetters } from '../../../store/storeGetters.constant';
    import { loginConstants } from '../login.constants';
    import LoginError from '../LoginError';

    export default {
        name: 'UsernameRecoveryOptions',
        created() {
            if (this.userRecoveryOptions.secondaryEmail == null) {
                this.option = 'email';
                this.toggleProgressIndicator();
                this.submitUsernameRecoveryOption(this.option)
                    .then(() => {
                        this.toggleProgressIndicator();
                        this.codeSent = true;
                    })
                    .catch(() => {
                        //TODO: handle error
                        this.toggleProgressIndicator();
                        this.codeSent = false;
                    });
            } else {
                this.codeSent = false;
            }
        },
        components: { LoginError },
        data: () => ({
            loginConstants,
            valid: true,
            componentNames: loginConstants.componentNames,
            codeSent: true,
            email: {
                primaryEmailCheckbox: null,
                secondaryEmailCheckbox: null,
            },
            option: [],
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        methods: {
            ...mapActions({
                submitUsernameRecoveryOption: `auth/${storeAction.submitUsernameRecoveryOption}`,
            }),
            submit() {
                this.toggleProgressIndicator();

                if (this.email.primaryEmailCheckbox && this.email.secondaryEmailCheckbox) {
                    this.option = 'bothemails';
                }
                if (this.email.primaryEmailCheckbox && !this.email.secondaryEmailCheckbox) {
                    this.option = 'email';
                }
                if (this.email.secondaryEmailCheckbox && !this.email.primaryEmailCheckbox) {
                    this.option = 'secondaryemail';
                }
                this.submitUsernameRecoveryOption(this.option)
                    .then(() => {
                        this.toggleProgressIndicator();
                        this.codeSent = true;
                    })
                    .catch(() => {
                        //TODO: handle error
                        this.toggleProgressIndicator();
                        this.codeSent = false;
                    });
            },
        },
        computed: {
            ...mapGetters({
                userRecoveryOptions: `auth/${storeGetters.userRecoveryOptions}`,
            }),
            checkEmptyObject() {
                return Object.values(this.email).every((x) => {
                    return x === null || x === '';
                });
            },
            selectedRecoveryDetails() {
                if (this.email.primaryEmailCheckbox && this.email.secondaryEmailCheckbox) {
                    return (
                        this.userRecoveryOptions.email.toString() +
                        loginConstants.AND +
                        this.userRecoveryOptions.secondaryEmail.toString()
                    );
                }
                if (this.email.primaryEmailCheckbox && !this.email.secondaryEmailCheckbox) {
                    return this.userRecoveryOptions.email.toString();
                }
                if (this.email.secondaryEmailCheckbox && !this.email.primaryEmailCheckbox) {
                    return this.userRecoveryOptions.secondaryEmail.toString();
                }
                if (!this.email.secondaryEmailCheckbox && !this.email.primaryEmailCheckbox) {
                    return this.userRecoveryOptions.email.toString();
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .username-recovery {
        &__title {
            padding: 5px 10px 20px 5px;
            font-size: 16px;
            color:$black;
            opacity: 0.9;
            
        }

        &__name {
            font-size: 20px;
            color: $ypo-blue;
            text-align: center;
            padding-bottom: 5px;
        }

        &__reset-title {
             padding: 5px 10px 30px 5px;
            font-size: 16px;
            color:$black;
            opacity: 0.9;
            
        }

        &__success {
            padding: 10px 5px;
            font-size: 16px;
            color:$black;
            opacity: 0.9;
            display: flex;
            flex-wrap: wrap;

            &-message {
                
                padding: 5px 10px 20px 5px;
            }

            &-email {
                color: $ypo-gold;
                word-break: break-all;
            }
        }
    }

    #submit_reset_code_btn {
        .v-btn__content {
            color: $white;
        }
    }

    .v-input--selection-controls{
        margin-top: 0;
        padding-top: 0;
    }
    .v-input--selection-controls .v-input__slot {
        margin-bottom: 0;
    }
</style>
